// extracted by css-extract-rspack-plugin
export default {"page":"styles-module__page__GcIH7","subnav":"styles-module__subnav__jKUp9"};